import { render, staticRenderFns } from "./PendingReservations.vue?vue&type=template&id=682221be&"
import script from "./PendingReservations.vue?vue&type=script&lang=js&"
export * from "./PendingReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports